export const SHIFT_NOT_VIEWABLE_STATUSES = ['no_show', 'cancelled'] as const;
export const SHIFT_JOIN_STATUSES = ['active'] as const;
export const SHIFT_START_STATUSES = ['scheduled'] as const;

export function isShiftViewable(status: string): boolean {
  return !SHIFT_NOT_VIEWABLE_STATUSES.includes(status as (typeof SHIFT_NOT_VIEWABLE_STATUSES)[number]);
}

export function canJoinShift(status: string): boolean {
  return SHIFT_JOIN_STATUSES.includes(status as (typeof SHIFT_JOIN_STATUSES)[number]);
}

export function canStartShift(status: string): boolean {
  return SHIFT_START_STATUSES.includes(status as (typeof SHIFT_START_STATUSES)[number]);
}

export function shiftNotViewableMessage(status: string): string {
  if (status === 'no_show') return 'This shift was marked as no-show. Contact your manager.';
  if (status === 'cancelled') return 'This shift was cancelled.';
  return 'This shift cannot be viewed.';
}
